import { useQuery } from 'react-query';

import { getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary } from 'src/client/spendesk-api';
import { type GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponseOK } from 'src/client/spendesk-api-types';
import { type QueryError } from 'src/core/api/queryError';
import { useCompany } from 'src/core/modules/app/hooks/useCompany';

type Options = {
  enabled?: boolean;
  onError?: (error: QueryError<unknown>) => void;
};

export type LineItemThreeWayMatchSummary =
  GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponseOK['purchaseOrderLines'][number];

export const useLineItemsSummaryQuery = (
  purchaseOrderId: string,
  { enabled = true, onError }: Options = {},
) => {
  const company = useCompany();

  return useQuery<
    GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponseOK,
    QueryError<unknown>
  >(
    ['purchase-orders', purchaseOrderId, 'three-way-match', 'lines-summary'],
    async (): Promise<GetV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummaryResponseOK> => {
      const response =
        await getV2ApiCompanyIdPurchaseOrdersPurchaseOrderIdThreeWayMatchLinesSummary(
          {
            path: { companyId: company.id, purchaseOrderId },
          },
        );
      if (response.statusCode !== 200) {
        throw new Error(
          `Invalid three way match response ${response.body.reason}`,
        );
      }
      return response.body;
    },
    {
      enabled,
      onError,
    },
  );
};
